export const CHARACTER_KEYWORDS = {
  personality: [
    '勇敢', '臆病', '冷静', '情熱的', '慎重', '衝動的', '楽観的', '悲観的',
    '社交的', '内向的', '誠実', '狡猾', '優しい', '厳格', '寛容', '頑固',
    '創造的', '保守的', '理想主義', '現実主義', '独立心が強い', '依存的',
    '自信家', '控えめ', '野心的', '無欲', '完璧主義', 'おおらか',
    '神経質', 'のんき', '責任感が強い', '無責任', '正義感が強い', '利己的',
    '献身的', '自己中心的', '協調的', '独断的', '感受性豊か', '鈍感',
    '論理的', '感情的', '几帳面', 'ずぼら', '行動的', '思索的',
    '明るい', '陰気', '素直', 'ひねくれ者', '純粋', '計算高い',
    '忍耐強い', '短気', '寛大', '執念深い', '柔軟', '融通が利かない',
    '積極的', '消極的', '大胆', '小心', '堅実', '冒険好き',
    '真面目', 'ふざけ好き', '礼儀正しい', '無礼', '謙虚', '傲慢',
    '親切', '冷酷', '温厚', '激情的', '平和主義', '好戦的',
    '倹約家', '浪費家', '几帳面', 'だらしない', '潔癖', '無頓着',
    '用心深い', '無警戒', '疑り深い', '信じやすい', '悲観的', '楽天的'
  ],
  
  occupation: [
    '騎士', '魔法使い', '商人', '農民', '貴族', '学者', '医者', '兵士',
    '冒険者', '盗賊', '暗殺者', '錬金術師', '鍛冶屋', '料理人', '宿屋の主人',
    '吟遊詩人', '占い師', '神官', '修道士', '船乗り', '漁師', '狩人',
    '探偵', '記者', '作家', '画家', '音楽家', '俳優', '監督', '科学者',
    '発明家', '技術者', 'プログラマー', '経営者', '会社員', '教師', '弁護士',
    '政治家', '外交官', '軍人', '警察官', '消防士', '看護師', '薬剤師',
    '建築家', '大工', '電気技師', '配管工', '庭師', '清掃員', '運転手',
    'パイロット', '宇宙飛行士', 'スポーツ選手', 'コーチ', '審判', 'トレーナー',
    '美容師', 'デザイナー', 'モデル', 'カメラマン', '編集者', '翻訳家',
    '通訳', '秘書', '受付', '販売員', 'バーテンダー', 'ウェイター',
    '配達員', '郵便局員', '銀行員', '保険営業', '不動産業者', '税理士',
    '会計士', 'コンサルタント', '研究者', '考古学者', '歴史家', '哲学者',
    '心理学者', '社会学者', '人類学者', '生物学者', '物理学者', '数学者',
    '天文学者', '地質学者', '気象予報士', '環境活動家', 'NGO職員',
    '傭兵', '賞金稼ぎ', '密偵', '情報屋', '闇商人', '奴隷商人'
  ],
  
  background: [
    '孤児', '貴族の子', '平民出身', '異国人', '流浪者', '元軍人', '元犯罪者',
    '名家の末裔', '没落貴族', '成り上がり', '天才', '努力家', '幸運児',
    '不運な星の下', '予言の子', '呪われた血筋', '英雄の子孫', '裏切り者の子',
    '戦争孤児', '疫病の生き残り', '村の生き残り', '元奴隷', '解放された囚人',
    '追放者', '亡命者', '復讐者', '守護者', '継承者', '開拓者',
    '都会育ち', '田舎育ち', '山育ち', '海辺育ち', '砂漠育ち', '雪国育ち',
    '地下都市出身', '空中都市出身', '異世界から', '未来から', '過去から',
    '記憶喪失', '二重人格', '人体実験の被験者', '改造人間', 'クローン',
    '人工生命', 'AI', 'サイボーグ', '半人半獣', '混血', '純血',
    '養子', '私生児', '双子の片割れ', '三つ子', '末っ子', '長子',
    '一人っ子', '大家族', '孤独な家庭', '虐待経験', '過保護に育つ',
    '英才教育', '放任主義', 'スパルタ教育', '宗教的家庭', '無神論家庭',
    '芸術家家系', '学者家系', '武人家系', '商人家系', '職人家系',
    '農家', '漁師家系', '遊牧民', '定住民', '都市国家市民', '帝国臣民',
    '共和国市民', '王国民', '部族民', '少数民族', '先住民', '移民',
    '難民', '政治亡命者', '経済移民', '宗教難民', '戦争避難民'
  ],
  
  motivation: [
    '復讐', '愛', '正義', '富', '名声', '権力', '知識', '自由',
    '平和', '破壊', '創造', '探求', '守護', '救済', '贖罪', '証明',
    '生存', '繁栄', '支配', '解放', '復活', '覚醒', '進化', '超越',
    '家族の幸せ', '故郷の復興', '世界平和', '真実の追求', '美の追求',
    '完璧の追求', '不老不死', '時間旅行', '次元移動', '神になる',
    '悪を倒す', '善を広める', 'バランスを保つ', '運命を変える', '予言を成就',
    '呪いを解く', '封印を解く', '契約を果たす', '約束を守る', '借りを返す',
    '恩を返す', '罪を償う', '過去を清算', '未来を変える', '現在を守る',
    '伝統を守る', '革新を起こす', '秩序を保つ', '混沌を生む', '調和を作る',
    '対立を解消', '統一を実現', '分離を促進', '独立を勝ち取る', '従属から脱却',
    '差別撤廃', '平等実現', '自由獲得', '権利擁護', '義務遂行',
    '使命達成', '天命遂行', '宿命克服', '因縁解消', '業を背負う',
    '徳を積む', '悟りを開く', '真理到達', '極致を目指す', '限界突破',
    '自己実現', '自己犠牲', '自己保存', '自己変革', '自己否定',
    '他者救済', '他者支配', '他者理解', '他者否定', '他者承認'
  ],
  
  fear: [
    '死', '痛み', '孤独', '裏切り', '失敗', '成功', '責任', '自由',
    '束縛', '変化', '停滞', '未知', '既知', '光', '闇', '高所',
    '閉所', '広場', '水', '火', '雷', '虫', '動物', '人間',
    '群衆', '孤立', '接触', '分離', '統合', '分裂', '消滅', '永遠',
    '忘却', '記憶', '真実', '嘘', '愛', '憎しみ', '無関心', '執着',
    '喪失', '獲得', '貧困', '富裕', '病気', '健康', '老い', '若さ',
    '醜さ', '美しさ', '弱さ', '強さ', '無知', '知識', '無力', '全能',
    '普通', '特別', '平凡', '非凡', '正気', '狂気', '秩序', '混沌',
    '静寂', '騒音', '清潔', '汚染', '純粋', '堕落', '聖なるもの', '邪悪',
    '神', '悪魔', '天使', '堕天使', '霊', '幽霊', '呪い', '祝福',
    '魔法', '科学', '自然', '人工', '生', '死後', '転生', '消滅',
    '審判', '許し', '罰', '報い', '因果', '運命', '偶然', '必然'
  ],
  
  skill: [
    '剣術', '槍術', '弓術', '格闘術', '暗殺術', '隠密術', '変装術', '話術',
    '交渉術', '詐術', '錬金術', '魔術', '召喚術', '治癒術', '予知術',
    '読心術', '変身術', '瞬間移動', '時間操作', '空間操作', '重力操作',
    '元素操作', '精神操作', '肉体強化', '感覚強化', '再生能力', '不死身',
    '透視', '千里眼', '未来視', '過去視', '霊視', '気配察知', '危険察知',
    '嘘発見', '感情読み取り', '記憶読み取り', '記憶操作', '幻覚作成',
    '料理', '裁縫', '鍛冶', '木工', '石工', '農業', '漁業', '狩猟',
    '採集', '薬草知識', '毒物知識', '医術', '獣医術', '助産術', '看護',
    '音楽', '絵画', '彫刻', '舞踊', '演技', '文筆', '詩作', '作曲',
    '楽器演奏', '歌唱', '語り', '暗記', '速読', '計算', '推理', '分析',
    '戦略', '戦術', '指揮', '兵站', '諜報', '暗号', '地図作成', '航海',
    '操船', '騎乗', '御者', '飛行', '潜水', '登山', 'サバイバル',
    '追跡', '罠作成', '開錠', 'スリ', '賭博', '手品', '曲芸', '腹話術'
  ],
  
  appearance: [
    '長身', '小柄', '中肉中背', '痩身', 'がっしり', '筋肉質', 'しなやか',
    '太め', '骨太', '華奢', '均整', '不均衡', 'アスリート体型', 'モデル体型',
    '黒髪', '茶髪', '金髪', '赤毛', '銀髪', '白髪', '青髪', '緑髪',
    '紫髪', '虹色', 'グラデーション', 'ツートーン', '長髪', '短髪',
    'ミディアム', 'ロング', 'ショート', 'ボブ', 'ポニーテール', 'ツインテール',
    '三つ編み', 'お団子', 'アフロ', 'モヒカン', '坊主', 'スキンヘッド',
    '黒い瞳', '茶色い瞳', '青い瞳', '緑の瞳', '灰色の瞳', '金色の瞳',
    '赤い瞳', '紫の瞳', 'オッドアイ', '三白眼', '切れ長', 'つり目',
    'たれ目', '大きな目', '細い目', '一重', '二重', '奥二重',
    '彫りが深い', '平たい顔', '面長', '丸顔', '四角い顔', '三角顔',
    'たまご型', '鷲鼻', '団子鼻', '上向き鼻', '低い鼻', '高い鼻',
    '厚い唇', '薄い唇', '大きな口', '小さな口', '八重歯', '出っ歯',
    'えくぼ', 'そばかす', 'ほくろ', '傷跡', '刺青', 'ピアス',
    '眼鏡', 'サングラス', 'モノクル', '眼帯', '仮面', 'ベール'
  ],
  
  quirk: [
    '口癖がある', '方言が強い', '敬語を使う', 'タメ口', '古風な話し方',
    '独特の笑い方', '咳払い', '舌打ち', '指を鳴らす', '髪をいじる',
    '爪を噛む', '貧乏ゆすり', '腕組み', '頬杖', '首を傾げる',
    '眉をひそめる', 'ウインク', '舌を出す', '鼻歌', '口笛',
    '独り言', '寝言', 'いびき', '歯ぎしり', '夢遊病', '不眠症',
    '過眠症', '偏食', '大食い', '少食', '酒豪', '下戸', '甘党',
    '辛党', 'コーヒー中毒', '紅茶党', '煙草', 'ギャンブル好き',
    '収集癖', '潔癖症', '不潔', '時間に正確', 'ルーズ', '几帳面',
    'だらしない', '物忘れ', '記憶力抜群', '方向音痴', '地図が読める',
    '計算が得意', '計算が苦手', '手先が器用', '不器用', '運動神経抜群',
    '運動音痴', '音楽の才能', '音痴', '絵が上手い', '絵心なし',
    '字が綺麗', '悪筆', '早口', 'ゆっくり話す', '声が大きい', '声が小さい',
    '高い声', '低い声', 'ハスキーボイス', '美声', '訛り', '吃音',
    '朝型', '夜型', '寒がり', '暑がり', '汗っかき', '冷え性',
    '健康', '病弱', 'アレルギー', '持病', '怪我しやすい', '治りが早い'
  ],
  
  relationship: [
    '親友', '幼馴染', '恋人', '片思い', '両思い', '三角関係', '不倫',
    '師弟', '先輩後輩', '同僚', '上司部下', '主従', '相棒', 'パートナー',
    '夫婦', '恋人未満', '友達以上', '腐れ縁', '悪友', '親友', 'ライバル',
    '宿敵', '天敵', '好敵手', '戦友', '同志', '仲間', '家族',
    '兄弟', '姉妹', '双子', '親子', '祖父母と孫', 'いとこ', '遠縁',
    '義理の関係', '血縁', '他人', '知人', '顔見知り', '初対面',
    '片思い', '両片思い', '元恋人', '元夫婦', '別居中', '復縁',
    '略奪愛', '禁断の恋', '年の差', '身分違い', '種族違い',
    '保護者', '被保護者', '恩人', '恩義', '債権者', '債務者',
    '共犯者', '被害者', '加害者', '目撃者', '傍観者', '介入者',
    '仲介者', '調停者', '扇動者', '追随者', 'リーダー', 'フォロワー',
    '崇拝者', 'アンチ', 'ファン', 'ストーカー', '護衛', 'ボディーガード'
  ],
  
  emotion: [
    '喜び', '悲しみ', '怒り', '恐怖', '嫌悪', '驚き', '期待', '失望',
    '希望', '絶望', '愛', '憎しみ', '情熱', '無気力', '興奮', '冷静',
    '幸福', '不幸', '満足', '不満', '安心', '不安', '信頼', '不信',
    '尊敬', '軽蔑', '感謝', '恨み', '誇り', '恥', '罪悪感', '無罪',
    '嫉妬', '羨望', '優越感', '劣等感', '共感', '無関心', '同情', '憐憫',
    '慈愛', '残酷', '寛容', '不寛容', '忍耐', '焦り', '落ち着き', '動揺',
    '確信', '疑念', '楽観', '悲観', '積極', '消極', '勇気', '臆病',
    '決意', '迷い', '覚悟', '未練', '執着', '諦め', '受容', '拒絶',
    '肯定', '否定', '賛成', '反対', '協力', '対立', '調和', '不和',
    '平穏', '混乱', '緊張', 'リラックス', '集中', '散漫', '興味', '退屈',
    '感動', '無感動', '感激', '失望', '歓喜', '落胆', '高揚', '沈鬱'
  ]
}

export function getRandomKeywords(category: keyof typeof CHARACTER_KEYWORDS, count: number = 3): string[] {
  const keywords = CHARACTER_KEYWORDS[category]
  const shuffled = [...keywords].sort(() => Math.random() - 0.5)
  return shuffled.slice(0, count)
}

// 全カテゴリから重複なしでランダムに選ぶ
export function getRandomKeywordsFromAll(count: number = 5, seed?: number): string[] {
  // すべてのカテゴリのキーワードを集める
  const allKeywords: string[] = []
  Object.values(CHARACTER_KEYWORDS).forEach(categoryKeywords => {
    allKeywords.push(...categoryKeywords)
  })
  
  // シード値がある場合は擬似ランダムを使用
  if (seed !== undefined) {
    // シンプルな擬似ランダム生成器
    let random = seed
    const pseudoRandom = () => {
      random = (random * 9301 + 49297) % 233280
      return random / 233280
    }
    
    // Fisher-Yatesシャッフル with 擬似ランダム
    const shuffled = [...allKeywords]
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(pseudoRandom() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
    }
    return shuffled.slice(0, count)
  }
  
  // 通常のランダム
  const shuffled = [...allKeywords].sort(() => Math.random() - 0.5)
  return shuffled.slice(0, count)
}

export function getAllRandomKeywords(): Record<string, string[]> {
  return {
    personality: getRandomKeywords('personality', 5),
    occupation: getRandomKeywords('occupation', 1),
    background: getRandomKeywords('background', 2),
    motivation: getRandomKeywords('motivation', 2),
    fear: getRandomKeywords('fear', 2),
    skill: getRandomKeywords('skill', 3),
    appearance: getRandomKeywords('appearance', 3),
    quirk: getRandomKeywords('quirk', 3),
    relationship: getRandomKeywords('relationship', 2),
    emotion: getRandomKeywords('emotion', 3)
  }
}